import Grid from "@material-ui/core/Grid";
import * as React from "react";

import Container from "./Container";
import CustomerGroupFilterMarketShare from "./CustomerGroupFilterMarketShare";
import MarketShareMap from "./MarketShareMap";
import MarketShareOverview from "./MarketShareOverview";

class MarketShare extends React.Component {
  public render() {
    return (
      <Container>
        <Grid container={true} spacing={2}>
          <Grid item={true} xs={12}>
            <CustomerGroupFilterMarketShare />
          </Grid>
          <Grid item={true} xs={12}>
            <MarketShareMap />
          </Grid>
          <Grid item={true} xs={12}>
            <MarketShareOverview />
          </Grid>
        </Grid>
      </Container>
    );
  }
}

export default MarketShare;



// WEBPACK FOOTER //
// ./src/components/MarketShare.tsx